import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import createPersistedState from "vuex-persistedstate"; // vuex持久化

const store = new Vuex.Store({
    state: {
        ver: "",
        homeIframeUrl: "",
        homeLang: "en", // 首页页面默认英文
        langOnPage: {
            IntroMarket: "en", // 首页
            other: "zh"
        },
        sideMenu: [],
        subMenu: [],
        orderMenu: [],
        recordPositionMenu: [],
        commonInfo: {},
        userInfo: [{
                rank_id: "",
                rid: ""
            },
            {}
        ],
        isLogin: "",
        isRepeat: true, // 是否循环请求数据
        token: "abcabaac",
        banner: "首页",
        pcFlag: "", // 是否是电脑
        shortName: ''
    },
    mutations: {
        setData: function(state, data) {
            state[data.key] = data.value;
        },
        set_homeLang: function(state, data) {
            state.homeLang = data;
        },
        set_ver: function(state, data) {
            state.ver = data;
        },
        set_langOnPage: function(state, data) {
            state.langOnPage = data;
        },
        set_homeIframeUrl: function(state, data) {
            state.homeIframeUrl = data;
        },
        set_newsIframeUrl: function(state, data) {
            state.newsIframeUrl = data;
        },
        set_pcFlag: function(state, data) {
            state.pcFlag = data;
        },
        set_banner: function(state, data) {
            state.banner = data;
        },
        set_isLogin: function(state, data) {
            state.isLogin = data;
        },
        set_isRepeat: function(state, data) {
            state.isRepeat = data;
        },
        set_token: function(state, data) {
            state.token = data;
        },
        set_recordPositionMenu: function(state, data) {
            state.recordPositionMenu = data;
        },
        set_sideMenu: function(state, data) {
            state.sideMenu = data;
        },

        set_subMenu: function(state, data) {
            state.subMenu = data;
        },
        set_orderMenu: function(state, data) {
            state.orderMenu = data;
        },
        set_userInfo: function(state, data) {
            state.userInfo = data;
        },
        set_commonInfo: function(state, data) {
            state.commonInfo = data;
        }
    },
    plugins: [createPersistedState()]
});

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js